import { changeBranch as changeBranchApi } from '@/apis/userAuthApi'
import { getProfile as getUserHoSo } from '@/apis/userApi'
import { unwrapLoginPayload, extractTokensFromPayload } from '@/components/login/loginPayload'
import { normalizeDetailResponse } from '@/utils/apiResponseUtils'
import { tokenStorage, profileStorage } from '@/services/tokenStorage'

/** Phát trên `window` sau khi đổi chi nhánh không reload — `detail: { duAnId, chiNhanhId }`. */
export const CHI_NHANH_CHANGED_EVENT = 'banhang:chi-nhanh-changed'

export type ChangeBranchOptions = {
  /** Mặc định `true`: reload cả trang. `false`: chỉ đổi token/profile rồi phát `CHI_NHANH_CHANGED_EVENT`. */
  reload?: boolean
}

/**
 * Đổi chi nhánh đang đứng: lấy token mới, cập nhật profile rồi reload trang (hoặc phát sự kiện).
 * Trả `false` khi BE không trả access token (caller tự báo lỗi); lỗi mạng → throw.
 */
export async function changeBranchSession(
  duAnId: number,
  chiNhanhId: number,
  options: ChangeBranchOptions = {},
): Promise<boolean> {
  const { reload = true } = options
  const res = await changeBranchApi(duAnId, chiNhanhId)
  const d = unwrapLoginPayload(res)
  const { accessToken, refreshToken: refreshFromRes } = extractTokensFromPayload(d)
  if (!accessToken?.trim()) return false
  const prevRefresh = tokenStorage.getRefreshToken()
  const refreshToStore =
    refreshFromRes != null && String(refreshFromRes).trim() !== '' ? refreshFromRes : prevRefresh ?? null
  tokenStorage.setTokens(accessToken.trim(), refreshToStore, 'user')
  const prev = (profileStorage.getProfile() as Record<string, unknown> | null) ?? {}
  profileStorage.setProfile({
    ...prev,
    duAn: d.duAn ?? prev.duAn,
    chiNhanh: d.chiNhanh ?? prev.chiNhanh,
    type: 'user',
  })
  try {
    const profileRes = await getUserHoSo()
    const userData = normalizeDetailResponse(profileRes) as Record<string, unknown>
    const merged = (profileStorage.getProfile() as Record<string, unknown> | null) ?? {}
    profileStorage.setProfile({
      ...merged,
      ...userData,
      duAn: d.duAn ?? merged.duAn,
      chiNhanh: d.chiNhanh ?? merged.chiNhanh,
      type: 'user',
    })
  } catch {
    /* giữ profile từ payload đổi chi nhánh */
  }
  if (reload) {
    window.location.reload()
  } else {
    window.dispatchEvent(new CustomEvent(CHI_NHANH_CHANGED_EVENT, { detail: { duAnId, chiNhanhId } }))
  }
  return true
}
